import axios from "../../../axios";

export const getBannerInfo = () => {
  const response = axios.get(`orders/ad-list/`);
  return response;
};
